import { render, staticRenderFns } from "./submit.vue?vue&type=template&id=67f7f7c4&scoped=true&"
import script from "./submit.vue?vue&type=script&lang=js&"
export * from "./submit.vue?vue&type=script&lang=js&"
import style0 from "./submit.vue?vue&type=style&index=0&id=67f7f7c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f7f7c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f7f7c4')) {
      api.createRecord('67f7f7c4', component.options)
    } else {
      api.reload('67f7f7c4', component.options)
    }
    module.hot.accept("./submit.vue?vue&type=template&id=67f7f7c4&scoped=true&", function () {
      api.rerender('67f7f7c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/investigate/components/submit.vue"
export default component.exports